import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { FILL_TOASTER } from './actionTypes';
import { localStorage } from '../../utils/BrowserStorageUtils';
/**
 * Access toast data from the store by reducing the whole store of data down to just the toast slice of data
 *
 * @param {Object} [state={}] The initial state for the reducer.
 * @param {function} action The specified action creator.
 *
 * @returns The toast data
 */

function toastReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;

  if (action.type === FILL_TOASTER) {
    localStorage.setItem('toast', action.toast);
    return _Object$assign({}, state, {
      toast: action.toast
    });
  }

  return _Object$assign({}, state);
}

export default {
  toastReducer: toastReducer
};